import SlideOverModal from './SlideOverModal'

export default SlideOverModal
